'use client';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["colorSet", "className", "isMobile", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext } from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { addColorSet, deprecatedOverlayDirections } from "../../styles/index.mjs";
import { TypeList } from "../TypeList/index.mjs";
import { PopoverDesktop } from "./PopoverDesktop.mjs";
import { PopoverMobile } from "./PopoverMobile.mjs";
export var PopoverMobileContext = /*#__PURE__*/createContext({
  isMobile: false
});
function PopoverNavigationComponent(_ref) {
  var _ref$colorSet = _ref.colorSet,
    colorSet = _ref$colorSet === void 0 ? 'base' : _ref$colorSet,
    className = _ref.className,
    isMobile = _ref.isMobile,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var Popover = isMobile ? PopoverMobile : PopoverDesktop;
  return /*#__PURE__*/React.createElement(Popover, Object.assign({
    className: addColorSet(colorSet, className),
    $colorSet: colorSet
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.PopoverNavigation
  }), /*#__PURE__*/React.createElement(TypeList, {
    condensedAll: true,
    listStyleReset: true
  }, /*#__PURE__*/React.createElement(PopoverMobileContext.Provider, {
    value: {
      isMobile: !!isMobile
    }
  }, children)));
}
var popoverNavigationHelpers = _objectSpread({}, deprecatedOverlayDirections);

/**
 * A popover that renders a simple list of PopoverNavigationLinks.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-popovernavigation--docs) |
 * [Encore site](https://encore.spotify.net/web/components/popover#navigation-popover) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/PopoverNavigation) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-12481&t=p9BSbkCzNpWDGLQr-1)
 */
export var PopoverNavigation = Object.assign(PopoverNavigationComponent, popoverNavigationHelpers);